<template>
  <div>
    <el-result icon="success" title="成功!" subTitle="提交成功">
      <template slot="extra">
        <el-button type="primary" @click="toIndex">返回</el-button>
      </template>
    </el-result>
  </div>
</template>
<script>
export default {
  methods: {
    toIndex() {
      this.$router.push({ name: "rich" });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>